import { IReportAction } from '../report-data.service';
import { IObject } from '../../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class BaseReportActionsHandler {
  protected eventHandler: Subscription;

  /**
   * @description Current report id
   */
  public reportId: number;
  /**
   * @description Selected report action
   * @type IReportAction
   */
  public action: IReportAction;
  /**
   * @description Row selection in report grid, array of selected report rows
   * @summary Array of selected report rows
   */
  public rowSelection: IObject[];

  /**
   * @description Code will be executed from this method
   * @summary Base method will always return true
   * @return Promise<any>
   */
  public execute(): Promise<any> {
    return Promise.resolve();
  }
}